import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

/**
 * Refetches all active queries and exposes the refetching state.
 *
 * Active queries are those whose `useQuery` hooks are currently mounted,
 * so no explicit query-key list needs to be maintained.
 */
export const useRefreshActiveQueries = () => {
  const queryClient = useQueryClient();
  const [isRefetching, setIsRefetching] = useState(false);

  const refetch = useCallback(async () => {
    setIsRefetching(true);
    try {
      // NOTE: Refetches active queries (queries that are currently rendered)
      await queryClient.refetchQueries();
    } finally {
      setIsRefetching(false);
    }
  }, [queryClient]);

  return { isRefetching, refetch };
};
